module.exports = __webpack_public_path__ + "img/lock.34f17ac8.svg";